import { Api } from '../lib'

const TYPE = {
  get_brands: 'GET_BRANDS'
}

const api = new Api()

const fetchBrands = () => (dispatch, getState) => api
  .get('brands')
  .then( brands => dispatch({type: TYPE.get_brands, payload: brands.data}) )

export default {
  TYPE,
  fetchBrands
}
